import React from 'react';
import PropTypes from 'prop-types';

import isMotoGp from '../../../utils/isMotoGp';

function HeartIcon({ isSaved = false, onClick, status }) {
  const brandColour = isMotoGp ? '#007aff' : '#512C9D';
  const colour = status === 'ended' ? '#89898E' : status === 'in-progress' ? '#018617' : brandColour;

  return (
    <svg
      aria-label={`Press to ${isSaved ? 'remove' : 'add'} this event to your saved events`}
      className={`c-event-schedule__event-heart ${isSaved ? 'c-event-schedule__event-heart--saved' : ''}`}
      fill="none"
      height="18"
      onClick={onClick}
      onKeyDown={onClick}
      role="button"
      tabIndex={0}
      viewBox="0 0 22 18"
      width="22"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.7973 4.75897C18.4545 -0.934566 12.5974 1.05808 11.1364 3.33547C7.03619 -1.50401 1.51115 2.18935 1.05091 5.32451C0.336434 10.1915 7.32922 15.0073 11.1364 17C19.9188 11.5912 21.6759 8.74445 20.7973 4.75897Z"
        fill={isSaved ? colour : undefined}
        strokeLinejoin="round"
        stroke={colour}
        strokeWidth="2"
      />
    </svg>
  );
}

HeartIcon.propTypes = {
  isSaved: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  status: PropTypes.string.isRequired,
};

export default HeartIcon;
